import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Observable } from 'rxjs';

import { BaseComponent, FormatService, FormlyService, GridService, ModalService } from 'tms-lib';
import { OrderProperty } from '../../../models';
import {
  PurchaseContractPropertyService,
  PurchaseOrderPropertyService,
  SalesOrderPropertyService,
} from '../../../services';
import { OrderPropertyModalComponent } from '../order-property-modal/order-property-modal.component';

@Component({
  selector: 'app-order-properties',
  templateUrl: './order-properties.component.html',
  styleUrl: './order-properties.component.scss',
})
export class OrderPropertiesComponent extends BaseComponent implements OnInit {
  @Input() orderHeaderId: string;
  @Input() salesOrder: boolean;
  @Input() purchaseContract = false;

  model$: Observable<OrderProperty[]>;
  fields: FormlyFieldConfig[];

  columnDefs: ColDef[] = [
    this.gridService.text('heading', $localize`Heading`),
    this.gridService.text('displayText', $localize`Text`),
    this.gridService.text('trueString', $localize`True`),
  ];

  constructor(
    private purchaseOrderPropertyService: PurchaseOrderPropertyService,
    private salesOrderPropertyService: SalesOrderPropertyService,
    private purchaseContractProperty: PurchaseContractPropertyService,
    private gridService: GridService,
    private formlyService: FormlyService,
    private modalService: ModalService,
    private formatService: FormatService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {
    if (!this.orderHeaderId) {
      this.orderHeaderId = this.route.snapshot.paramMap.get('id');
    }
    this.getModel();
  }

  getModel() {
    this.model$ = this.salesOrder
      ? this.salesOrderPropertyService.search('', this.orderHeaderId)
      : this.purchaseContract
        ? this.purchaseContractProperty.search('', this.orderHeaderId)
        : this.purchaseOrderPropertyService.search('', this.orderHeaderId);
  }

  edit(model: OrderProperty) {
    this.orderProperty(model.id, model.orderHeaderId);
  }

  private orderProperty(id: string, purchaseOrderHeaderId?: string) {
    const { modal, component } = this.modalService.openMedium<OrderPropertyModalComponent>(OrderPropertyModalComponent);
    component.id = id;
    component.orderHeaderId = purchaseOrderHeaderId;
    component.salesOrder = this.salesOrder;
    component.purchaseContract = this.purchaseContract;
    modal.result.then(
      () => this.getModel(),
      () => {},
    );
  }
}
